import { render, staticRenderFns } from "./IconLsAction.vue?vue&type=template&id=33f8bfa0"
import script from "./IconLsAction.vue?vue&type=script&lang=js"
export * from "./IconLsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports